export const TIMELINE_FETCH = "TIMELINE_FETCH";
export const TIMELINE_HAS_MORE = "TIMELINE_HAS_MORE";
export const TIMELINE_RESET = "TIMELINE_RESET";
